export const PageLoading = ({ full = false }) => (
  <div className={`flex items-center justify-center ${full ? "min-h-screen bg-white" : "py-24"}`} data-testid={full ? "app-loading" : "page-loading"}>
    <span className="data-label">Caricamento…</span>
  </div>
);
